import styled from 'styled-components';

export const StyledRelatedPosts = styled.div`
  .related-posts {
    margin-top: 60px;
    padding-top: 40px;
    border-top: 2px solid ${({ theme }) => theme.colors.mercury};

    &__title {
      margin-bottom: 24px;

      h3 {
        color: ${({ theme }) => theme.colors.mineShaft};
      }
    }

    &__grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
    }

    &__card {
      display: flex;
      flex-direction: column;
      border-radius: 14px;
      overflow: hidden;
      background: ${({ theme }) => theme.colors.athensGray};
      transition:
        box-shadow 0.2s ease,
        transform 0.2s ease;
      text-decoration: none;

      &:hover {
        box-shadow: 0 4px 16px ${({ theme }) => theme.colors.getTransparentColor(theme.colors.black, 0.1)};
        transform: translateY(-2px);
      }
    }

    &__card-image {
      width: 100%;
      height: 160px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;
      }
    }

    &__card:hover &__card-image img {
      transform: scale(1.05);
    }

    &__card-body {
      padding: 16px;
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    &__card-category {
      width: fit-content;
    }

    &__card-title {
      flex: 1;

      p {
        color: ${({ theme }) => theme.colors.mineShaft};
      }
    }
  }

  @media (max-width: 768px) {
    .related-posts {
      margin-top: 40px;
      padding-top: 28px;

      &__grid {
        grid-template-columns: 1fr;
        gap: 16px;
      }

      &__card-image {
        height: 180px;
      }
    }
  }
`;
